module.exports = __webpack_public_path__ + "img/jygm-home.b96cf472.jpg";